export default "__VITE_ASSET__DS5Sb2V6__"